export const botMessageType = 'bot';
export const selfMessageType = 'self';

export function createMessagePayload({
    userId,
    senderType,
    type,
    messageId,
    message,
    data,
    slots, metadata
}) {
    return {
        userId,
        senderType,
        type,
        messageId,
        message,
        data,
        slots,
        metadata
    }
}

export function createSelfMessagePayload(inputText) {
    return createMessagePayload({
        senderType: selfMessageType,
        type: "text",
        messageId: "user",
        message: inputText,
    })
}

export function createBotMessagePayload(message) {

    // if message is received as unsupported format
    if (!message.type) {
        message = {
            type: 'default',
            content: message,
            metadata: {}
        }
    }

    return createMessagePayload({
        senderType: botMessageType,
        type: message.type,
        messageId: "bot",
        message: message.content,
        metadata: message.metadata
    })
}